var lib_core = require("lib-core");

var PosAngleFlipData = require("./../../abstract/posAngleFlipData.js");

var PcbTerminal = require("./pcbTerminal.js");
var PadData = require("./../../footprint/padData.js");
var PcbHole = require("./pcbHole.js");
var HoleData = require("./../../footprint/holeData.js");
var lib_geometry = require("lib-geometry");
//var SmdPadData = require("./../../footprint/smdPadData.js");

var PcbElementData = function (footprintInstance, pos, angle, onTopLayer) {
    var self = this;

    this.observeAncestor = true;
    this.registerInstanceClass(["pads"], PadData, PcbTerminal);
    this.registerInstanceClass(["holes"], HoleData, PcbHole);
    lib_core.InstanceBuilder.call(this);

    this.addPosAngleFlip(pos, angle); // TODO: pcb element cannot be flipped!

    this.onTopLayer = this.value("onTopLayer", true); // TOP or BOTTOM layer

    this.segmentedGeometry = this.cachedFunction("segmentedGeometry",
        function(){
            // TODO: this is the bounding box instead of the poly
            var poly = lib_geometry.BoundingBox.emptyBoundingBox;
            self.pads.forEach(function(pad) {
                poly = pad.boundingBox().merge(poly);
            });
            return poly;
        },
        [this.pos, this.angle]
    );

    this.boundingBox = this.cachedFunction("boundingBox",
        function(){
            return self.segmentedGeometry();
        },
        [this.segmentedGeometry]
    );

    this.onInit("init", this.initialize);

    if(onTopLayer != undefined) this.onTopLayer(onTopLayer);
    if (footprintInstance != undefined) this.ancestor(footprintInstance);
};
lib_core.inherit(PcbElementData, lib_core.InstanceBuilder);
lib_core.mixin(PcbElementData, PosAngleFlipData);
lib_core.JsonParser.registerClass(PcbElementData, "PcbElementData");

module.exports = PcbElementData;

PcbElementData.prototype.initialize = function () {
    this.packageInstance = this.ancestor().parent();
    this.componentInstance = this.packageInstance.parent();

    this.create3dShadows();
};



PcbElementData.prototype.create3dShadows = function () {
    var self = this;

    this.packageMesh = this.shadow("packageMesh", function(){
        var mesh = this.packageInstance.description().mesh().clone();
        var footprintInstance = this.template().template().template();
        var position = (footprintInstance.model3dPosition())? footprintInstance.model3dPosition() : new lib_geometry.Coord3d(0,0,0);
        var rotation = (footprintInstance.model3dRotation())? footprintInstance.model3dRotation() : new lib_geometry.Coord3d(0,0,0);
        mesh.rotateX(rotation.x);
        mesh.rotateY(rotation.y);
        mesh.rotateZ(rotation.z);
        mesh.translate(
            position.x, 
            position.y,
            position.z 
        );

        if(!this.onTopLayer()) {
            mesh.rotateY(180);
            mesh.translate(0, 0, self.parent().boardThickness + self.parent().copperThickness * 2);
        }
        return mesh;
    }, null,
    [this.onTopLayer, 
     [this.template, this.template.onBubble], 
     this.packageInstance.description])


    this.allHoles = this.cachedFunction("allHoles",
        function (precision){
            var outlines = [];
            self.holes.forEach(function(id, hole){
                var geom = hole.description().outlineGeometry(precision);
                var poly = new lib_geometry.Polygon(geom.points);
                if(!self.onTopLayer()){
                    poly = poly.flip(-1);
                }
                outlines.push(poly);
            });

            self.pads.forEach(function(id, pad){
                if(pad.description().getDrillSegmentedGeometry){
                    var geom = pad.description().getDrillSegmentedGeometry(precision);
                    var poly = new lib_geometry.Polygon(geom.points);
                    if(!self.onTopLayer()){
                        poly = poly.flip(-1);
                    }
                    outlines.push(poly);
                }
            });
            return outlines;
        },
        [this.pads, this.holes, this.onTopLayer]
    );

    this.copperMesh = this.cachedFunction("copperMesh",
        function (precision){
            var merged = new lib_geometry.TriangleMesh();
            self.pads.forEach(function(id, pad){
                var mesh = pad.description().mesh(precision);
                if(mesh.isEmpty()) return;
                mesh = mesh.copy();
                merged.mergeMesh(mesh);
            });

            return merged;
        },
        [this.pads]
    );

    this.silkscreenMesh = this.cachedFunction("silkscreenMesh",
        function (precision){
            var merged = new lib_geometry.TriangleMesh();
            this.description().silkscreen.forEach(function(id, silk){
                var mesh = silk.mesh(precision);
                if(mesh.isEmpty()) return;
                mesh = mesh.copy();
                merged.mergeMesh(mesh);
            });

            return merged;
        },
        [this.description]
    );

};
